import Inline from '@perpay-web/components/design-system/Inline/Inline';
import Stack from '@perpay-web/components/design-system/Stack/Stack';

import styles from './PerpaySplitInfo.scss';

const PerpaySplitInfo = ({ amount = '$XXX' }) => (
    <Stack className={styles.container}>
        <Inline className={styles.item}>
            <div className={styles['item__icon--one']} />
            <div className={styles.item__text}>
                Add your bank account to Perpay
            </div>
        </Inline>
        <Inline className={styles.item}>
            <div className={styles['item__icon--two']} />
            <div className={styles.item__text}>
                Log into your benefits portal and switch your direct deposit to
                your Perpay Account.
            </div>
        </Inline>
        <Inline className={styles.item}>
            <div className={styles['item__icon--three']} />
            <div className={styles.item__text}>
                On each payday, your full benefit direct deposit will be sent to
                your Perpay Account.
            </div>
        </Inline>
        <Inline className={styles.item}>
            <div className={styles['item__icon--four']} />
            <div className={styles.item__text}>
                On the same day, your direct deposit minimum of {amount} will be
                applied to your Perpay Account and the remainder of your deposit
                will be transferred to your linked bank account*
            </div>
        </Inline>
    </Stack>
);

export default PerpaySplitInfo;
